import { useCallback } from 'react';
import { showToast } from '../../utils/toast';
import { listingsService } from '../../api';

// Mirrors mobile Step 4 (sell.tsx Location). Maps to backend's `step: 3`.
// Persists title/price/isNegotiable/color from earlier-step state along with
// location fields.
export const useDetailsHandler = () => {
  const handleNext = useCallback(
    async (formData: Record<string, any>): Promise<boolean> => {
      const required = ['county', 'city', 'address'];
      for (const f of required) {
        if (!formData[f]) {
          showToast.error(`Please fill in the ${f} field`);
          return false;
        }
      }

      const params = new URLSearchParams(window.location.search);
      const id = params.get('id') || undefined;

      if (!id) {
        showToast.error('Save Step 1 first');
        return false;
      }

      const payload = {
        id,
        step: 3,
        mode: 'update' as const,
        data: {
          title: formData.title,
          price: formData.price ? Number(formData.price) : undefined,
          description: formData.description || undefined,
          color: formData.color || undefined,
          location: formData.county,
          county: formData.county,
          address: formData.address,
          city: formData.city,
          country: 'Albania',
          isNegotiable: formData.isNegotiable !== false,
        },
      };

      try {
        await listingsService.upsertStep(payload);
        showToast.success('Location saved');
        return true;
      } catch (err) {
        console.error('[LISTING][STEP 3] failed', err);
        showToast.error('Failed to save location');
        return false;
      }
    },
    []
  );

  const handleBack = useCallback(() => true, []);

  return { handleNext, handleBack };
};
